/**
 * Gerador pseudoaleatório determinístico (mulberry32).
 * O estado é um único inteiro de 32 bits, então cabe no snapshot da partida e na rede.
 */
export type RngState = number;

export function seedRng(seed: number): RngState {
  return seed >>> 0;
}

/** Avança o gerador e devolve [novo estado, inteiro sem sinal de 32 bits]. */
export function nextUint32(state: RngState): [RngState, number] {
  const next = (state + 0x6d2b79f5) >>> 0;
  let t = next;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return [next, (t ^ (t >>> 14)) >>> 0];
}

/** Número em [0, 1). */
export function nextFloat(state: RngState): [RngState, number] {
  const [next, value] = nextUint32(state);
  return [next, value / 4294967296];
}

/** Inteiro em [min, max], com os dois extremos incluídos. */
export function nextInt(state: RngState, min: number, max: number): [RngState, number] {
  const [next, value] = nextFloat(state);
  return [next, min + Math.floor(value * (max - min + 1))];
}
